import { OrderAdjustmentsFormValues } from 'pages/OrderAdjustments/hooks/useOrderAdjustmentsForm';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Identifier, SimpleForm, useListContext } from 'react-admin';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { TextInput } from 'shared/react-admin/Inputs';

import { StyledBox, StyledDialog } from './OrderAdjustmentsGroupCommentDialog.styled';
import { OrderAdjustmentsGroupCommentResetButton } from './OrderAdjustmentsGroupCommentResetButton';

export const OrderAdjustmentsGroupCommentDialog = ({ open, onClose }: DialogProps) => {
  const translate = useTypedTranslate();
  const { selectedIds } = useListContext();
  const { getValues, setValue } = useFormContext<OrderAdjustmentsFormValues>();

  const setSelectedOrdersComment = (comment: string | null) => {
    const orderAdjustments = getValues('orderAdjustments');
    selectedIds.forEach((orderId: Identifier) => {
      const index = orderAdjustments.findIndex((order) => order.orderId === orderId);

      if (index !== -1) {
        setValue(`orderAdjustments.${index}.comment`, comment);
      }
    });
  };

  const handleSubmit: SubmitHandler<FieldValues> = ({ comment }) => {
    setSelectedOrdersComment(comment);
    onClose();
  };

  return (
    <StyledDialog maxWidth="md" onClose={onClose} open={open}>
      <SimpleForm onSubmit={handleSubmit} sx={{ padding: 0 }} toolbar={<></>}>
        <StyledBox>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title={translate('app.orderAdjustments.dialogs.groupCommentDialog.title')}
            titleSize="smallBold"
          />
          <CardContent>
            <TextInput
              fullWidth
              label={translate('app.orderAdjustments.dialogs.groupCommentDialog.label')}
              multiline
              required
              size="small"
              source="comment"
              variant="outlined"
            />
          </CardContent>
          <CardActionsButtons
            leftActionsSlot={[
              <OrderAdjustmentsGroupCommentResetButton
                key="reset-button"
                onReset={() => setSelectedOrdersComment(null)}
              />,
            ]}
            rightActionsSlot={[
              <CancelButton
                key="cancel-button"
                label={translate('app.orderAdjustments.dialogs.groupCommentDialog.buttons.cancel')}
                onClick={onClose}
                variant="outlined"
              />,
              <Button
                key="save-button"
                label={translate('app.orderAdjustments.dialogs.groupCommentDialog.buttons.save')}
                type="submit"
                variant="contained"
              />,
            ]}
          />
        </StyledBox>
      </SimpleForm>
    </StyledDialog>
  );
};
